import { watchSDKTokenInfo } from '@web-publish-id/shared/caches'
import { sharedConfig } from '@web-publish-id/shared/config'
const POPUP_WIDTH = 500
const POPUP_HEIGHT = 600

export function openPopup(url: string): Promise<any> {
  return new Promise((resolve, reject) => {
    const left = window.screenX + (window.outerWidth - POPUP_WIDTH) / 2
    const top = window.screenY + (window.outerHeight - POPUP_HEIGHT) / 2

    const popup = window.open(url, 'Login', `width=${POPUP_WIDTH},height=${POPUP_HEIGHT},left=${left},top=${top}`)

    if (!popup) {
      reject(new Error('Failed to open popup'))
      return
    }

    // 监听popup的消息
    const handleMessage = (event: MessageEvent) => {
      if (event.source !== popup) return

      if (event.data.type === 'success') {
        resolve(event.data.data)
      } else {
        reject(new Error('Login failed'))
      }

      cleanup()
      popup.close()
    }

    // 监听popup的消息
    window.addEventListener('message', handleMessage)

    const cleanup = () => {
      clearInterval(popupCheck)
      window.removeEventListener('message', handleMessage)
    }

    const popupCheck = setInterval(() => {
      if (!popup || popup.closed) {
        cleanup()
        reject(new Error('Login cancelled'))
      }
    }, 200)
  })
}

/**
 * 判断当前页面是否是主页面
 * @returns 是否是主页面
 */
export function isHostOrigin() {
  if (window.location.pathname.startsWith('/demo')) return false
  return window.location.origin === sharedConfig.origin
}
